export default "__VITE_ASSET__1wqDOMJw__"